import React from "react";
import { Box, Paper, Stack, useMediaQuery } from "@mui/material";
import { brandColors } from "../theme";

// Alto de la BottomToolbar (52px) más lo que sobresale el botón central.
const BOTTOM_NAV_CLEARANCE = 86;

// Botones de acción del detalle de un auto o una propiedad (Consultar,
// Reservar, WhatsApp). En celular quedan fijos abajo, arriba de la
// BottomToolbar, para que se vean sin tener que bajar hasta el final (en
// la app Android el botón quedaba tapado por la barra). En pantallas
// grandes se dibujan en el lugar, como siempre.
const ListingActionBar = ({ isGuest, children }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  if (!isMobile) return <>{children}</>;

  return (
    <>
      {/* Reserva el espacio de la barra al final del contenido. */}
      <Box sx={{ height: 72 }} />
      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          left: 12,
          right: 12,
          bottom: isGuest ? "calc(12px + env(safe-area-inset-bottom))" : `calc(${BOTTOM_NAV_CLEARANCE}px + env(safe-area-inset-bottom))`,
          zIndex: 1050,
          p: 1.25,
          borderRadius: 4,
          bgcolor: brandColors.backgroundPaper,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={1}>{children}</Stack>
      </Paper>
    </>
  );
};

export default ListingActionBar;
